import { API_URLS } from '@/constants/urls';
import { useAuth } from '@/contexts/AuthContext';
import { apiClient } from '@/services/apiClient';
import { GoogleLogin } from '@react-oauth/google';
import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';
import { useCompset } from '@/contexts/CompsetContext';

function GoogleOauth() {

    const { handleLogin, cleanUpAccount } = useAuth();
    const {setActiveCompset} = useCompset();
    const [loading, setLoading] = useState(false);

    const handleGoogleOauth = async (credential) => {

        setActiveCompset(null);
        cleanUpAccount();

        try {
            setLoading(true);

            const response = await apiClient.post(API_URLS.GOOGLE_OAUTH, {
                token: credential
            });

            handleLogin(response.data);

        } catch (error) {
            apiErrorHandler(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="relative w-full flex justify-center">
            <GoogleLogin
                size="large"
                text="continue_with"
                onSuccess={({ credential }) => handleGoogleOauth(credential)}
            />

            {loading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white/70 rounded-md">
                    <Loader2 className="w-5 h-5 animate-spin text-primary" />
                </div>
            )}
        </div>
    );
}

export default GoogleOauth;